'use client';

import React from 'react';
import HeroSection from './HeroSection';
import TrustIndicators from './TrustIndicators';
import ProductVerticals from './ProductVerticals';
import GeographicReach from './GeographicReach';
import CTASection from './CTASection';
import QuickAccessToolbar from './QuickAccessToolbar';

interface Testimonial {
  id: number;
  quote: string;
  author: string;
  company: string;
  country: string;
}

interface Certification {
  id: number;
  name: string;
  description: string;
  icon: string;
  image: string;
  alt: string;
}

interface Product {
  id: number;
  name: string;
  description: string;
  minOrder: string;
  packaging: string;
  image: string;
  alt: string;
  icon: string;
}

interface Market {
  id: number;
  region: string;
  countries: string[];
  icon: string;
  stats: string;
}

interface HomepageInteractiveProps {
  testimonials: Testimonial[];
  certifications: Certification[];
  products: Product[];
  markets: Market[];
  whatsappNumber: string;
}

const HomepageInteractive = ({
  testimonials,
  certifications,
  products,
  markets,
  whatsappNumber,
}: HomepageInteractiveProps) => {
  return (
    <>
      <HeroSection data-component-id="src/app/homepage/components/HomepageInteractive.tsx:64:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="64" data-component-end-line="64" data-component-file="HomepageInteractive.tsx" data-component-name="HeroSection" data-component-content="%7B%22elementName%22%3A%22HeroSection%22%7D" testimonials={testimonials} />
      <TrustIndicators data-component-id="src/app/homepage/components/HomepageInteractive.tsx:65:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="65" data-component-end-line="65" data-component-file="HomepageInteractive.tsx" data-component-name="TrustIndicators" data-component-content="%7B%22elementName%22%3A%22TrustIndicators%22%7D" certifications={certifications} />
      <ProductVerticals data-component-id="src/app/homepage/components/HomepageInteractive.tsx:66:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="66" data-component-end-line="66" data-component-file="HomepageInteractive.tsx" data-component-name="ProductVerticals" data-component-content="%7B%22elementName%22%3A%22ProductVerticals%22%7D" products={products} />
      <GeographicReach data-component-id="src/app/homepage/components/HomepageInteractive.tsx:67:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="67" data-component-end-line="67" data-component-file="HomepageInteractive.tsx" data-component-name="GeographicReach" data-component-content="%7B%22elementName%22%3A%22GeographicReach%22%7D" markets={markets} />
      <CTASection data-component-id="src/app/homepage/components/HomepageInteractive.tsx:68:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="68" data-component-end-line="68" data-component-file="HomepageInteractive.tsx" data-component-name="CTASection" data-component-content="%7B%22elementName%22%3A%22CTASection%22%7D" />
      <QuickAccessToolbar data-component-id="src/app/homepage/components/HomepageInteractive.tsx:69:6" data-component-path="src/app/homepage/components/HomepageInteractive.tsx" data-component-line="69" data-component-end-line="69" data-component-file="HomepageInteractive.tsx" data-component-name="QuickAccessToolbar" data-component-content="%7B%22elementName%22%3A%22QuickAccessToolbar%22%7D" whatsappNumber={whatsappNumber} />
    </>
  );
};

export default HomepageInteractive;